import serverConnect from "../services/serverConnect";

const applicationStore = {
    namespaced: true,

    state: {
        socketId: undefined
    },
    getters: {
        socketId: state => {
            return state.socketId;
        }
    },
    mutations: {
        setSocketId(state, socketId) {
            state.socketId = socketId;
        },
        clear(state) {
            state.socketId = undefined;
        }
    },
    actions: {
        initStore(context) {
            // The client is connected to the server, a unique id is given by the server to the client, that can be used to
            // uniquely identify the client during other transactions. For example during a rest call the client can provide the id
            // that the server will use to send back progress updates
            serverConnect.on("welcome", data => {
                console.log(data);
                context.commit("setSocketId", data.text);
            });
        },
        clear(context) {
            context.commit("clear");
        }
    }
};

export default applicationStore;
